export default "__VITE_ASSET__$0VUfd2r__"